import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import lastOperationsIcon from './../img/last-operations-icon.png';
import Dropdown from '../../../copms/Dropdown/Dropdown';
import { getFormatedDate } from '../../../helpers/fotmatDate';
import { request } from '../../../config';
import $ from 'jquery';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import AddDocumentDecree from '../../../copms/Modal/AddDocumentDecree';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class OtherBankPaid extends Component {
    state = {
        status: 1,
        endDate: null,
        beginDate: null,
        invoices: [],
        id: null,
        checkedItems: [],
        selectAllChecked: false,
        verificationOpen: false,
        verificationCode: null,
        statuses: [],
        statusId: null,
        invoiceNumber: '',
        bencName: '',
        open: false,
        item: null,
        payType: null,
        payableAmount: '',
        calculatedAmount: '',
        accountId: null,
        totalAmountWithComission: null,
        commission: null,
        isBlocked: 0,
        invoice: null,
        documentId: null,
        paymentAmount: '',
        paymentDate: null,
        files: []
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    componentDidMount() {
        this.getInvoiceList();
    }

    getInvoiceList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getInvoiceListRequestBody = {
            token: localStorage.getItem('token'),
            beginDate: getFormatedDate(this.state.beginDate, '-'),
            endDate: getFormatedDate(this.state.endDate, '-')
        }
        fetch(request("instruction/getInstrOtherBankPayments", getInvoiceListRequestBody))
            .then(res => res.text())
            .then((getInvoiceListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getInvoiceListResponse = JSON.parse(getInvoiceListResponseJSON);
                if (getInvoiceListResponse.status.statusCode !== 1) {
                    if (getInvoiceListResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getInvoiceListResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ invoices: getInvoiceListResponse.payments ? getInvoiceListResponse.payments : [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    downloadDocument = (document, documentName) => {
        let arrrayBuffer = base64ToArrayBuffer(document);
        saveFile(documentName, `application/${documentName.substring(documentName.lastIndexOf('.') + 1)}`, arrrayBuffer);
    }

    addFiles = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let deleteInvoiceRequestBody = {
            token: localStorage.getItem('token'),
            paymentDate: getFormatedDate(this.state.beginDate, '-'),
            paymentAmount: this.state.paymentAmount,
            paymentAmountCurr: 'AZN'
        }
        const file = Array.isArray(this.state.files) ? this.state.files[0] : null;
        let data = new FormData();
        data.append('reqObject', JSON.stringify(deleteInvoiceRequestBody));
        if (file) {
            data.append('file', file.files, file.fileName);
        }
        fetch(request("instruction/addInstrOtherBankPaymentForm", data, "POST_FORM"))
            .then(res => res.text())
            .then((deleteInvoiceResponseJSON) => {
                const JSON = require('true-json-bigint');
                let deleteInvoiceResponse = JSON.parse(deleteInvoiceResponseJSON);
                if (deleteInvoiceResponse.status.statusCode !== 1) {
                    if (deleteInvoiceResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(deleteInvoiceResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.setState({ open: false, files: [] });
                    this.getInvoiceList();
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    deleteDocument = (id) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let deleteInvoiceRequestBody = {
            token: localStorage.getItem('token'),
            id
        }
        fetch(request("instruction/deleteInstrOtherBankPayment", deleteInvoiceRequestBody, "POST"))
            .then(res => res.text())
            .then((deleteInvoiceResponseJSON) => {
                const JSON = require('true-json-bigint');
                let deleteInvoiceResponse = JSON.parse(deleteInvoiceResponseJSON);
                if (deleteInvoiceResponse.status.statusCode !== 1) {
                    if (deleteInvoiceResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(deleteInvoiceResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.getInvoiceList();
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    chooseFile = (event) => {
        let files = this.state.files;
        for (let i = 0; i < event.target.files.length; i++) {
            files.push({ files: event.target.files[i], fileName: event.target.files[i].name });
        }
        this.setState({ files: files });
    }
    deleteFile = (index) => {
        let files = this.state.files;
        files.splice(index, 1);
        this.setState({ files: files });
    }
    downloadFile = (index) => {
        let arrrayBuffer = this.state.files[index].files;
        saveFile(this.state.files[index].fileName, null, arrrayBuffer);
    }

    render() {
        let { invoices, beginDate, endDate, paymentAmount, open, files } = this.state;
        let { t } = this.props;
        return (
            <>
                <AddDocumentDecree open={open} files={files} amount={paymentAmount} beginDate={beginDate} endDate={endDate} updateDate={this.updateDate} updateAmount={(amount) => this.setState({ paymentAmount: amount })} chooseFile={this.chooseFile} deleteFile={this.deleteFile} downloadFile={this.downloadFile} triggerFunc={() => this.addFiles()} onClose={() => this.setState({ open: false })} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Tax orders')}</h2>
                    </div>
                    <button onClick={() => this.setState({ open: true })} className="dashboard-header-route-button">{t('Add document')}</button>
                </div>
                <div className="dashboard-salary-container">
                    <div className="dashboard-salary-container-data-section" style={{ marginTop: '1px' }}>
                        <div className="dashboard-transfer-list-header">
                            <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                <NavLink exact to="/dashboard/decree/list" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t('Active orders')}</NavLink>
                                <NavLink exact to="/dashboard/decree/history" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t('history')}</NavLink>
                                <NavLink exact to="/dashboard/decree/other-bank-paid" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t('Other bank paid orders')}</NavLink>
                            </div>
                        </div>
                        <div className="dashboard-salary-order-container">
                            <div className="dashboard-salary-order-container-box flex-nowrap mt-3">
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Started date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <StartDatePicker value={beginDate} name="beginDate" updateDate={this.updateDate} />
                                    </div>
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("expiration date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <EndDatePicker value={endDate} name="endDate" updateDate={this.updateDate} />
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-salary-order-container-box justify-content-end">
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" onClick={this.getInvoiceList}>{t("Search")}</button>
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.setState({ beginDate: null, endDate: null })}>{t("Clear")}</button>
                            </div>
                            {invoices.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                                </div> :
                                <><div style={{ height: "50vh", overflowY: "auto", overflowX: 'auto', width: "100%" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead style={{ position: 'sticky', top: 0, left: 0, zIndex: '100' }}>
                                            <tr className='border-0'>
                                                <th>{t("date")}</th>
                                                <th>{t("Amount")}</th>
                                                <th>{t("currency")}</th>
                                                <th>{t("Attached documents")}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoices.map(item => (
                                                <tr>
                                                    <td>{getFormatedDate(item.paymentDate, 'dd.mm.yyyy') || '--'}</td>
                                                    <td>{item.paymentAmount || '--'}</td>
                                                    <td>{item.paymentAmountCurr || '--'}</td>
                                                    <td>{item.fileDoc ? <><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" style={{ cursor: 'pointer' }} onClick={() => this.downloadDocument(item.fileDoc, item.fileName)}>
                                                        <path d="M19.5625 13.2506C25.7199 13.2506 28.5625 18.9345 28.5625 18.9345C28.5625 18.9345 25.7199 24.6183 19.5625 24.6183C13.4051 24.6183 10.5625 18.9345 10.5625 18.9345C10.5625 18.9345 13.4051 13.2506 19.5625 13.2506Z" stroke="black" stroke-linejoin="round" />
                                                        <path d="M22.2487 18.9345C22.257 19.3032 22.1914 19.6699 22.056 20.0131C21.9206 20.3562 21.718 20.6688 21.4601 20.9325C21.2022 21.1962 20.8942 21.4058 20.5542 21.5488C20.2142 21.6919 19.849 21.7656 19.4802 21.7656C19.1113 21.7656 18.7461 21.6919 18.4061 21.5488C18.0661 21.4058 17.7582 21.1962 17.5003 20.9325C17.2424 20.6688 17.0397 20.3562 16.9043 20.0131C16.7689 19.6699 16.7034 19.3032 16.7116 18.9345C16.7116 18.2 17.0034 17.4956 17.5227 16.9763C18.0421 16.457 18.7464 16.1652 19.4809 16.1652C20.2153 16.1652 20.9197 16.457 21.439 16.9763C21.9583 17.4956 22.2501 18.2 22.2501 18.9345H22.2487Z" stroke="black" stroke-linejoin="round" />
                                                    </svg></> : this.props.t('no item')}</td>
                                                    <td>
                                                        {item.isDeleted &&
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="#FA5252" viewBox="0 0 20 20" width="20px" height="20px" style={{ cursor: 'pointer' }}>
                                                                <path d="M 10.806641 2 C 10.289641 2 9.7956875 2.2043125 9.4296875 2.5703125 L 9 3 L 4 3 A 1.0001 1.0001 0 1 0 4 5 L 20 5 A 1.0001 1.0001 0 1 0 20 3 L 15 3 L 14.570312 2.5703125 C 14.205312 2.2043125 13.710359 2 13.193359 2 L 10.806641 2 z M 4.3652344 7 L 5.8925781 20.263672 C 6.0245781 21.253672 6.877 22 7.875 22 L 16.123047 22 C 17.121047 22 17.974422 21.254859 18.107422 20.255859 L 19.634766 7 L 4.3652344 7 z" onClick={() => this.deleteDocument(item.id)} />
                                                            </svg>}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                </>}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default translate('translation')(OtherBankPaid);